'use client';
import { isBinaryDownloadFile } from '#pplx/frontend/apps/ask/shared-ui-components/filePreviewUtils.js';
const TEXT_DOCUMENT_ASSET_TYPES = new Set([
    'RESEARCH_REPORT',
    'DOC_FILE',
    'DOCX_FILE',
    'PDF_FILE',
    'CODE_FILE',
]);
export function isTextDocumentAssetType(assetType, filename, mimeType) {
    if (!TEXT_DOCUMENT_ASSET_TYPES.has(assetType))
        return false;
    if (assetType !== 'CODE_FILE')
        return true;
    return !isBinaryDownloadFile({ filename, mimeType });
}
//# sourceMappingURL=TextDocumentPreviewShared.js.map